export const SCHEDULED = 2;
export const OPEN = 3;
export const IN_PROGRESS = 5;
export const IN_REVIEW = 7;
export const COMPLETED = 8;
export const ABANDONED = 11;
export const IN_MANUAL_REVIEW = 23;